

import React, { useState } from "react";
import Styles from "../../assets/scss/ItemCategories/ItemCategoriesTable.module.scss";
import settingStyles from "../../assets/scss/Settings/Settings.module.scss";
import { FaTrash } from "react-icons/fa";
import Pagination from "../../Components/Common/Pagination";
import DeleteConfirmModalLogout from "../../Components/Common/DeleteConfirmModalLogout";
import PopupWrapper from "../../Components/Common/PopupWrapper";
import AddItemCategories from "./AddItemCategories";
import { toast } from "react-toastify";
import { useDeleteItemCategoryMutation, useGetAllItemCategoriesQuery } from "../../slices/admin/admin";
import { getUserInfo } from "../../utils/user.util";
import ItemCategoriesTableBelow from "./ItemCategoriesTableBelow";
import { capitalize } from "../../utils/capitalize";

const ItemCategoriesTable = () => {

    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const offset = currentPage;

    const user = getUserInfo();


    const hasViewOnlyCategoryAccess = user?.roles?.[0]?.permissions?.some(
        (p) => p.functionality === "categories" && p.permissionType === "view only"
    );

    const { data, isLoading } = useGetAllItemCategoriesQuery({
        offset,
        limit,
        search,
    });

    const [deleteItem] = useDeleteItemCategoryMutation();

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const [showPopup, setShowPopup] = useState(false);

    const items = data?.result || [];



    const totalPages = Math.ceil((data?.total || 0) / limit);

    const openDeletePopup = (item) => {
        setSelectedItem(item);
        setDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
      //  alert("This feature is under the development.");
        try {
            const res = await deleteItem(selectedItem._id).unwrap();
            toast.success(res.message);
        } catch (err) {
            toast.error(err?.data?.message || "Delete failed");
        }
        setDeleteModalOpen(false);
        setSelectedItem(null);
    };

    if (hasViewOnlyCategoryAccess) {
        return <>

            <div className={Styles.parentss}>
                <>
                    <ItemCategoriesTableBelow />
                </>
            </div>

        </>;
    }


    return (
        <div className={Styles.parent}>
            <div className={settingStyles.headerRow}>
                <h2 className={settingStyles.header}>Item Categories</h2>
            </div>

            <div className={Styles.box}>

                {/* Search + Clear + Add */}
                <div className={Styles.headerRow}>
                    <div className={Styles.leftControls}>
                        <input
                            type="text"
                            placeholder="Search items..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className={Styles.searchBox}
                        />

                        <button
                            className={Styles.clearBtn}
                            onClick={() => {
                                setSearch("");
                                setCurrentPage(1);
                            }}
                        >
                            Clear All
                        </button>
                    </div>

                    <button className={Styles.addBtn} onClick={() => setShowPopup(true)}>
                        + Add New Item
                    </button>
                </div>

                {/* TABLE */}
                <div className={Styles.tableWrapper}>
                    <table className={Styles.customTable}>
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Item Category</th>
                                {/* <th>Description</th> */}
                                <th className={Styles.actionCol}>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan="3" className={Styles.noData}>Loading...</td>
                                </tr>
                            ) : items.length === 0 ? (
                                <tr>
                                    <td colSpan="3" className={Styles.noData}>No items found</td>
                                </tr>
                            ) : (
                                items.map((item, index) => (
                                    <tr key={item._id}>
                                        <td>{(currentPage - 1) * limit + index + 1}</td>
                                        <td>{item.itemCategory ? capitalize(item.itemCategory) : "-"}</td>
                                        {/* <td>{item.description || "-"}</td> */}
                                        <td>
                                            <FaTrash
                                                className={Styles.deleteIcon}
                                                onClick={() => openDeletePopup(item)}
                                            />
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>

                    <div className={Styles.paginationContainer}>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={(page) => setCurrentPage(page)}
                        />

                        <select
                            className={Styles.inputsbtn}
                            value={limit}
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value={10}>10 rows</option>
                            <option value={25}>25 rows</option>
                            <option value={50}>50 rows</option>
                        </select>
                    </div>
                </div>
            </div>

            <DeleteConfirmModalLogout
                isOpen={deleteModalOpen}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteModalOpen(false)}
                title="Are You Sure?"
                heading="Delete Item"
                content={`Are you sure you want to delete "${selectedItem?.itemCategory}"? This action cannot be restored.`}
            />

            {showPopup && (
                <PopupWrapper onClose={() => setShowPopup(false)}>
                    <AddItemCategories onClose={() => setShowPopup(false)} />
                </PopupWrapper>
            )}
        </div>
    );
};

export default ItemCategoriesTable;





